export enum jobsheetTatActions {
    DOWNLOAD_JOB_PREFIX_EXCEL_LOADING = "@@jobsheetTatReports/DOWNLOAD_JOB_PREFIX_EXCEL_LOADING",
    DOWNLOAD_JOB_PREFIX_EXCEL_SUCCESS = "@@jobsheetTatReports/DOWNLOAD_JOB_PREFIX_EXCEL_SUCCESS",
    DOWNLOAD_JOB_PREFIX_EXCEL_ERROR = "@@jobsheetTatReports/DOWNLOAD_JOB_PREFIX_EXCEL_ERROR",

    GET_JOBSHEET_COURIER_OPTION_LOADING = "@@jobsheetTatReports/GET_JOBSHEET_COURIER_OPTION_LOADING",
    GET_JOBSHEET_COURIER_OPTION_SUCCESS = "@@jobsheetTatReports/GET_JOBSHEET_COURIER_OPTION_SUCCESS",
    GET_JOBSHEET_COURIER_OPTION_ERROR = "@@jobsheetTatReports/GET_JOBSHEET_COURIER_OPTION_ERROR",

    JOBSHEET_TAT_CLEAR = "@@jobsheetTatReports/JOBSHEET_TAT_CLEAR",
}